import { useLocation, Link } from "wouter-preact"
import { api_fetch } from "../api/client.tsx"
import { useFormState } from "@/components/form/form_state.tsx"
import { CenterColumnContainer } from "../components/LoginScreen.tsx"
import { useSearchParams } from "@/utils"
import { setUser } from "./user.tsx"
import { User } from "@/api/user.tsx"

import { Button } from "@/components/ui/button.tsx"
import { Logo } from "../app/logo.tsx"
import { Form } from "@/components/form/Form.tsx"
import { PasswordInput } from "@/components/form/Input.tsx"

export function SetPassword() {
  const [, setLocation] = useLocation()
  const params = useSearchParams<{ token?: string }>()
  const form = useFormState({
    password: "",
    confirmPassword: "",
  })

  if (!params.token) {
    return (
      <CenterColumnContainer title="Invalid Link" logo={<Logo />}>
        <div class="text-center space-y-4">
          <p class="text-red-600">This password setup link is invalid or has expired.</p>
          <Link to="/login" class="text-blue-600 hover:text-blue-800">
            Go to login
          </Link>
        </div>
      </CenterColumnContainer>
    )
  }

  async function onSubmit() {
    if (form.password.value !== form.confirmPassword.value) {
      form.set_form_errors(["Passwords do not match"])
      return
    }

    const res = await api_fetch<User>("/auth/set_initial_password", {
      body: {
        token: params.token,
        password: form.password.value,
      },
    })

    if (!res.ok) {
      form.set_form_errors([res.error.message])
      return
    }

    setUser(res.value.data)
    setLocation("/select-org")
  }

  return (
    <CenterColumnContainer title="Set Your Password" logo={<Logo />}>
      <Form class="space-y-6" onSubmit={onSubmit} alerts={form.form_alerts}>
        <PasswordInput
          label="Password"
          required={true}
          bind={form.password}
          placeholder="Enter your password"
        />
        <PasswordInput
          label="Confirm Password"
          required={true}
          bind={form.confirmPassword}
          placeholder="Confirm your password"
        />
        <Button type="submit" className="w-full" variant="tertiary">
          Set Password
        </Button>
      </Form>
    </CenterColumnContainer>
  )
}
